import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import { REQUEST } from '../../utils/statusConstants'
import BulkUpload from './BulkUpload'
import Panel from './Panel'
import {
  List as VirtualizedList,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  InfiniteLoader,
} from 'react-virtualized'
import BlankPanel from './BlankPanel'

export default connect(
  (state, { contacts }) => ({
    contacts: contacts
      ? contacts
      : Object.values(state.contacts.contactsWithEmailsByID),
    loadStatus: state.loadStatus.contacts,
    onboarding: !state.onboarding.setup_complete,
  }),
  null,
)(
  withStyles(theme => ({
    progress: {
      margin: theme.spacing.unit * 2,
    },
    window: {
      height: 'calc(100vh - 112px)',
      [theme.breakpoints.down('xs')]: {
        height: 'calc(100vh - 56px)',
      },
      [theme.breakpoints.up('sm')]: {
        borderRadius: 15,
        overflow: 'hidden',
      },
    },
    windowWithOnboarding: {
      height: 'calc(100vh - 155px)',
      [theme.breakpoints.down('xs')]: {
        height: 'calc(100vh - 128px)',
      },
      [theme.breakpoints.up('sm')]: {
        borderRadius: 15,
        overflow: 'hidden',
      },
    },
  }))(
    class Panels extends Component {
      constructor() {
        super()
        this.state = { expanded: null }
        this.cache = new CellMeasurerCache({
          fixedWidth: true,
          defaultHeight: 64,
        })
      }

      renderRow = ({ index, isScrolling, key, style, parent }) => (
        <CellMeasurer
          key={key}
          cache={this.cache}
          parent={parent}
          columnIndex={0}
          rowIndex={index}
        >
          <div style={style}>
            {isScrolling ? (
              <BlankPanel />
            ) : (
              <Panel
                groupID={this.props.groupID}
                contact={this.props.contacts[index]}
              />
            )}
          </div>
        </CellMeasurer>
      )

      handleChange = (expanded, panel) => {
        this.setState({
          expanded: expanded ? panel : false,
        })
      }

      bindListRef = ref => {
        this.list = ref
      }

      render() {
        const {
          classes,
          contacts,
          loadStatus,
          heightClass,
          onboarding,
          paginated,
          loading,
          listFn,
          cursor,
        } = this.props

        const list = contacts

        const loadMoreRows = loading ? () => {} : () => listFn()

        const isRowLoaded = ({ index }) => {
          return !cursor || index < list.length
        }

        const rowRenderer = ({ index, isScrolling, key, style, parent }) => {
          return (
            <CellMeasurer
              key={key}
              cache={this.cache}
              parent={parent}
              columnIndex={0}
              rowIndex={index}
            >
              <div style={style}>
                {!isRowLoaded ? (
                  <BlankPanel />
                ) : isScrolling ? (
                  <BlankPanel />
                ) : (
                  <Panel
                    index={index}
                    deleteThenFn={this.props.deleteThenFn}
                    groupID={this.props.groupID}
                    contact={this.props.contacts?.[index]}
                    campaignID={this.props.campaignID}
                  />
                )}
              </div>
            </CellMeasurer>
          )
        }

        return contacts.length ? (
          <div
            className={
              heightClass
                ? heightClass
                : onboarding
                ? classes.windowWithOnboarding
                : classes.window
            }
            style={{ backgroundColor: '#fff' }}
          >
            {paginated ? (
              <InfiniteLoader
                isRowLoaded={isRowLoaded}
                loadMoreRows={() => {
                  loadMoreRows()
                }}
                rowCount={cursor ? list.length + 1 : list.length}
              >
                {({ onRowsRendered, registerChild }) => (
                  <AutoSizer>
                    {({ width, height }) => (
                      <VirtualizedList
                        ref={registerChild}
                        onRowsRendered={onRowsRendered}
                        width={width}
                        height={height}
                        deferredMeasurementCache={this.cache}
                        rowHeight={this.cache.rowHeight}
                        rowRenderer={rowRenderer}
                        rowCount={
                          cursor ? contacts.length + 1 : contacts.length
                        }
                        overscanRowCount={3}
                        estimatedRowSize={64}
                      />
                    )}
                  </AutoSizer>
                )}
              </InfiniteLoader>
            ) : (
              <AutoSizer>
                {({ width, height }) => (
                  <VirtualizedList
                    ref={this.bindListRef}
                    width={width}
                    height={height}
                    deferredMeasurementCache={this.cache}
                    rowHeight={this.cache.rowHeight}
                    rowRenderer={this.renderRow}
                    rowCount={contacts.length}
                    overscanRowCount={3}
                    estimatedRowSize={64}
                  />
                )}
              </AutoSizer>
            )}
          </div>
        ) : loadStatus === REQUEST || loadStatus === null ? (
          <CircularProgress className={classes.progress} color="secondary" />
        ) : (
          <BulkUpload />
        )
      }
    },
  ),
)
